<script>
  import { onMount } from "svelte"
  import InnerCard from "./innerCard.svelte"
  import { createEventDispatcher } from "svelte"
  const dispatch = createEventDispatcher()
  import bulkJson from "../../../Stores/jsonBulkData"
  import Pagination from "../../../../../../Shared/Table/Components/pagination.svelte"
  // import Pagination from "../../../Shared/pagination.svelte"
  /**
   * @type {Array<template>} - it consists of filtered json list. It displayed in list.
   */
  let sortData = []
  /**
   * @type {boolean} whether to disable release button or not
   */
  let disableReleaseBtn = false
  /**
   * @type {Number} maximum page count
   */
  let maxPage
  /**
   * @type {Number} active page of the pagination
   */
  let activePage = 1

  onMount(() => {
    // Reorder the $bulkJson array to group documents based on their properties

    // Filter and concatenate documents with no fileHash that have failed
    const failedDocuments = $bulkJson.filter((a) => !a.fileHash && a.isDocumentFailed)

    // Filter and concatenate documents with no fileHash that have not failed
    const waitingDocuments = $bulkJson.filter((a) => !a.fileHash && !a.isDocumentFailed)

    // Filter and concatenate documents with a fileHash
    const completedDocuments = $bulkJson.filter((a) => a.fileHash)

    // Update the $bulkJson array to have failed, waiting, and completed documents grouped together
    $bulkJson = [...failedDocuments, ...waitingDocuments, ...completedDocuments]

    maxPage = Math.ceil($bulkJson.length / 10)

    listEntries($bulkJson)
  })

  /**
   * @description function for what are list need to show
   * @function listEntries
   */
  const listEntries = ($bulkJson) => {
    // Calculate the maximum number of pages based on the length of jsonData and the number of entries per page
    maxPage = Math.ceil($bulkJson.length / 10)

    // Create an empty array to store the sorted data
    sortData = []

    // Iterate through jsonData starting from the index corresponding to the current page
    for (let i = 10 * (activePage - 1); i < $bulkJson.length; i++) {
      // Check if the sortData array has reached the desired number of entries per page
      if (sortData.length < 10) {
        // Add the current jsonData element to the sortData array
        sortData = [...sortData, $bulkJson[i]]
      }
    }
  }
</script>

<!-- <Pagination bind:sortData json={$bulkJson} /> -->

<div class="mt-6 flex w-full select-none flex-col items-center justify-between gap-3 text-sm sm:flex-row sm:gap-0 sm:text-base">
  <!-- How many entries shows in total entries -->
  <p class="font-medium text-gray-200">
    Showing {activePage * 10 - 10 + 1} to {activePage * 10 > $bulkJson.length ? $bulkJson.length : activePage * 10} of
    <span class="font-mono font-bold text-blue-500">{$bulkJson.length}</span>
    entries
  </p>

  {#if maxPage}
    <Pagination
      {maxPage}
      {activePage}
      on:pageNo={(e) => {
        activePage = e.detail
        listEntries($bulkJson)
      }}
    />
  {/if}
</div>

<div class="mt-6 flex w-full select-none flex-col gap-3">
  {#each sortData as document}
    <InnerCard
      {document}
      on:release={() => {
        listEntries($bulkJson)
        dispatch("release")
      }}
      bind:disableReleaseBtn
    />
  {:else}
    <h1>In processing ...</h1>
  {/each}
</div>
